<template>
  <div>
    <component :is="componentName"  component=""/>
  </div>
</template>

<script>
import LoanDetailPlan from "./Template/loanDetailPlan.vue";
import LoanDetailPlanWhenClose from "./Template/loanDetailPlanWhenClose.vue";
import PrincipleBalanceIsZero from "./Template/principleBalanceIsZero.vue";
import EducationStatusBreachOfPromise from "./Template/educationStatusBreachOfPromise.vue";
import ExternalBorrowerUnApproved from "./Template/externalBorrowerUnApproved.vue";
import IsRuledButNotRestructuring from "@/views/pages/Notification/Notification/Template/isRuledButNotRestructuring.vue";
import IsRestructuringAgingMoreThan90Days from "@/views/pages/Notification/Notification/Template/isRestructuringAgingMoreThan90Days.vue";
import isDraft from "@/views/pages/Notification/Notification/Template/isDraft.vue";
import { INotiActionType } from "@/constants/interface";

export default {
  computed: {
    componentName() {
      const map = {
        [INotiActionType.loanDetailPlan]: 'LoanDetailPlan',
        [INotiActionType.loanDetailPlanWhenClose]: 'LoanDetailPlanWhenClose',
        [INotiActionType.principleBalanceIsZero]: 'PrincipleBalanceIsZero',
        [INotiActionType.educationStatusBreachOfPromise]: 'EducationStatusBreachOfPromise',
        [INotiActionType.externalBorrowerUnApproved]: 'ExternalBorrowerUnApproved',
        [INotiActionType.isRuledButNotRestructuring]: 'IsRuledButNotRestructuring',
        [INotiActionType.isRestructuringAgingMoreThan90Days]: 'IsRestructuringAgingMoreThan90Days',
        [INotiActionType.isDraft]: 'isDraft',
      };
      return map[this.$route.params.action] || null;
    }
  },
  components: {
    LoanDetailPlan,
    LoanDetailPlanWhenClose,
    PrincipleBalanceIsZero,
    EducationStatusBreachOfPromise,
    ExternalBorrowerUnApproved,
    IsRuledButNotRestructuring,
    IsRestructuringAgingMoreThan90Days,
    isDraft,
  }
};
</script>
